import { Badge, BadgeProps, IconArrowUp, Text } from '@cmpsr/components';

type IncreasedRiskBadgeProps = {
  percentage?: string;
  isNonQuantifiable?: boolean;
} & BadgeProps;

export default function IncreasedRiskBadge({ percentage, isNonQuantifiable, ...props }: IncreasedRiskBadgeProps) {
  return (
    <Badge
      leadingIcon={isNonQuantifiable ? undefined : <IconArrowUp size="xs" />}
      justifyContent="center"
      w={isNonQuantifiable ? '60px' : 'max-content'}
      height="22px"
      py="2px"
      px="4px"
      backgroundColor="alert-error-default"
      borderRadius="radii-1"
      color="text-error"
      {...props}
    >
      <Text color="text-error" variant="text-body-floating-label-bold">
        {isNonQuantifiable ? <IconArrowUp size="xs" /> : percentage}
      </Text>
    </Badge>
  );
}
